import React from 'react';
import { ContentLayout, Container, Header, SpaceBetween } from '@cloudscape-design/components';
import { Button } from '../common/Button';

export const SkillManagementPage: React.FC = () => {
  return (
    <ContentLayout defaultPadding>
      <Container
        header={
          <Header variant="h1">
            Skill Management
          </Header>
        }
      >
        <SpaceBetween direction="horizontal" size="l">
          <Button variant="primary" icon="upload">
            Upload Skill
          </Button>
          <Button variant="secondary">
            Observability
          </Button>
        </SpaceBetween>
      </Container>
    </ContentLayout>
  );
};
